import Box from "@mui/material/Box";
import Avatar from "@mui/material/Avatar";
import { FcGoogle } from "react-icons/fc";
import {
  avatarInitial,
  firstNameInitial,
  isGoogleLinkedUser,
  stringToAvatarColor,
} from "../../utils/avatarFromName";

const badgeSize = 14;

function GoogleBadge() {
  return (
    <Box
      component="span"
      aria-label="Google sign-in"
      role="img"
      sx={{
        position: "absolute",
        right: -1,
        bottom: -1,
        width: badgeSize,
        height: badgeSize,
        borderRadius: "50%",
        bgcolor: "#fff",
        boxShadow: "0 0 0 1px rgba(38, 17, 52, 0.12)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        lineHeight: 0,
        pointerEvents: "none",
      }}
    >
      <FcGoogle size={10} aria-hidden />
    </Box>
  );
}

export default function UserManagementAvatar({ row }) {
  const name = row?.full_name || "?";
  const google = isGoogleLinkedUser(row);
  const letter = google ? firstNameInitial(name) : avatarInitial(name);
  const colorKey = google ? `${name}|google` : name;

  return (
    <Box
      className="userMgmtAvatarWrap"
      sx={{
        position: "relative",
        display: "inline-flex",
        flexShrink: 0,
        mr: "10px",
        verticalAlign: "middle",
      }}
    >
      {row?.avatar_url ? (
        <img
          className="cellImg"
          src={row.avatar_url}
          alt=""
          style={{ marginRight: 0 }}
        />
      ) : (
        <Avatar
          className="cellImg cellImgAvatar"
          sx={{
            width: 32,
            height: 32,
            mr: 0,
            fontSize: 14,
            fontWeight: 700,
            bgcolor: stringToAvatarColor(colorKey),
            color: "#fff",
          }}
        >
          {letter}
        </Avatar>
      )}
      {google ? <GoogleBadge /> : null}
    </Box>
  );
}
